import { useEffect, useState } from "react"
import { useQuery } from "urql"

import type { PaymentTerm, PaymentTermGetSuccess, Query } from "@/graphql/codegen/graphql"
import { GetPaymentTermDocument } from "@/graphql/codegen/graphql"

const useGetPaymentTerm = ({
  paymentTermId,
}: {
  paymentTermId: string
}): {
  paymentTerm: PaymentTerm | null
  paymentTermDetailsFetching: boolean
} => {
  const [paymentTerm, setPaymentTerm] = useState<PaymentTerm | null>(null)

  const [{ data: paymentTermDetail, fetching: paymentTermDetailsFetching }] = useQuery<Pick<Query, "paymentTerm">>({
    query: GetPaymentTermDocument,
    variables: { input: { paymentTermId } },
    pause: !paymentTermId,
  })

  useEffect(() => {
    if (paymentTermDetail) {
      setPaymentTerm((paymentTermDetail?.paymentTerm?.get as PaymentTermGetSuccess)?.paymentTerm)
    }
  }, [paymentTermDetail])

  return {
    paymentTerm,
    paymentTermDetailsFetching,
  }
}

export default useGetPaymentTerm
